import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "list", "items", "item", "prev", "next" ]

  prev(event) {
    this.listTarget.scrollBy({
      top: 0,
      left: -(this.itemTarget.clientWidth),
      behavior: 'smooth'
    });

  }

  next(event) {
    this.listTarget.scrollBy({
      top: 0,
      left: this.itemTarget.clientWidth,
      behavior: 'smooth'
    });

  }
}
